/**
 * A native `<select>` that matches the text fields.
 *
 * The disabled fade is part of the recipe. A select that stays full strength
 * while it cannot be changed reads as a choice somebody missed.
 */
export const SELECT_CLASS =
  'h-8 w-full rounded-md border border-default bg-surface px-2 text-sm text-primary-text transition-colors hover:border-strong focus-visible:outline-none disabled:opacity-60'
